<template>
    <BreadCrumb PageTitle="Ajouter un type de chargement" />
    <AddModalTypeChargement/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
     import AddModalTypeChargement from "@/components/TypeChargement/AddModalTypeChargement.vue";
  
    export default defineComponent({
      name: "AddTypeChargementPage",
      components: {
        BreadCrumb,
        AddModalTypeChargement,
      },
    });
  </script>